const FIELD_NAME_REG_EX = new RegExp(/^(?!(0))[a-zA-Z0-9 ]+$/);
const SPLIT_AT_LINE_BREAK_REG_EX = new RegExp(/\r?\n|\r|\n/g);
const OPTION_LIST_MAX_ROW_LENGTH = 100;

const  TicketManagementConstant = {
    FIELD_NAME_REG_EX,
    SPLIT_AT_LINE_BREAK_REG_EX,
    OPTION_LIST_MAX_ROW_LENGTH
};

export default TicketManagementConstant;